export default function ValentineThumbnail() {
  return (
    <svg
      viewBox="0 0 104 86"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
      width="100%"
      height="100%"
    >
      <rect width="104" height="86" fill="#F8BAD5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.5364 16.0769C50.3698 15.4179 53.1399 15.836 55.5847 16.9191C59.4749 18.6427 62.5958 22.0791 63.8849 25.6535C64.8694 21.9657 67.7197 18.2595 71.4835 16.2198C73.8344 14.9458 76.5622 14.3089 79.439 14.7405C82.1375 15.1456 84.9312 16.4859 87.6411 19.0586L88.1826 19.5898C91.3837 22.8391 92.4024 26.6042 91.9058 30.5683C91.4124 34.5055 89.4281 38.622 86.6687 42.645C81.1509 50.6896 72.4183 58.521 65.7408 64.0349L65.7325 64.0481C58.6399 59.0843 49.1542 51.9906 42.8587 44.4304C39.7119 40.6514 37.329 36.7163 36.465 32.8388C35.5949 28.9334 36.2715 25.1016 39.2063 21.6056L39.7034 21.0335C42.2004 18.2532 44.8785 16.6951 47.5364 16.0769Z"
        fill="#FF658C"
        fillOpacity="0.89"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.5364 13.3991C50.3698 12.7401 53.1399 13.1582 55.5847 14.2414C59.4749 15.965 62.5958 19.4014 63.8849 22.9757C64.8694 19.288 67.7197 15.5817 71.4835 13.5421C73.8344 12.2681 76.5622 11.6312 79.439 12.0628C82.1375 12.4678 84.9312 13.8081 87.6411 16.3809L88.1826 16.912C91.3837 20.1614 92.4024 23.9264 91.9058 27.8906C91.4124 31.8278 89.4281 35.9443 86.6687 39.9673C81.1509 48.0118 72.4183 55.8432 65.7408 61.3572L65.7325 61.3703C58.6399 56.4066 49.1542 49.3129 42.8587 41.7526C39.7119 37.9736 37.329 34.0385 36.465 30.161C35.5949 26.2557 36.2715 22.4239 39.2063 18.9278L39.7034 18.3557C42.2004 15.5754 44.8785 14.0174 47.5364 13.3991Z"
        stroke="#1F2022"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9118 36.7154C23.2336 36.1754 25.5036 36.518 27.507 37.4055C30.6947 38.8179 33.2522 41.6339 34.3085 44.5629C35.1152 41.541 37.4509 38.5039 40.5351 36.8325C42.4616 35.7886 44.6969 35.2666 47.0542 35.6203C49.2656 35.9522 51.5548 37.0505 53.7754 39.1588L54.2192 39.594C56.8423 42.2567 57.6771 45.3419 57.2701 48.5904C56.8658 51.8167 55.2398 55.1899 52.9786 58.4866C48.457 65.0786 41.3012 71.496 35.8294 76.0144L35.8225 76.0252C30.0105 71.9577 22.2375 66.1448 17.0786 59.9496C14.5 56.8529 12.5474 53.6283 11.8394 50.4509C11.1264 47.2506 11.6808 44.1107 14.0857 41.2458L14.4931 40.7771C16.5392 38.4988 18.7338 37.222 20.9118 36.7154Z"
        fill="#FF6565"
        fillOpacity="0.92"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.9118 34.5215C23.2336 33.9815 25.5036 34.3241 27.507 35.2117C30.6947 36.6241 33.2522 39.4401 34.3085 42.369C35.1152 39.3471 37.4509 36.3101 40.5351 34.6387C42.4616 33.5947 44.6969 33.0728 47.0542 33.4265C49.2656 33.7584 51.5548 34.8567 53.7754 36.9649L54.2192 37.4002C56.8423 40.0629 57.6771 43.1481 57.2701 46.3965C56.8658 49.6228 55.2398 52.9961 52.9786 56.2927C48.457 62.8848 41.3012 69.3022 35.8294 73.8206L35.8225 73.8314C30.0105 69.7638 22.2375 63.9509 17.0786 57.7557C14.5 54.659 12.5474 51.4344 11.8394 48.257C11.1264 45.0568 11.6808 41.9169 14.0857 39.052L14.4931 38.5832C16.5392 36.3049 18.7338 35.0282 20.9118 34.5215Z"
        stroke="#1F2022"
      />
    </svg>
  );
}
